export var storage = {
    get : function (key: string){
        if(localStorage.getItem(key)  != undefined){
            storage = JSON.parse(localStorage.getItem(key) || '');
            return storage
        }
    },
}